import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../services/apiService';
import { mapState } from 'vuex';
import { isArray, get, compact, cloneDeep, isEmpty } from 'lodash';
export default {
  name: 'CoreDtwinRuleEditCommands',
  props: {
    dtwin: {
      type: Object,
      required: false,
      default: function _default() {}
    },
    rule: {
      type: Object,
      required: true
    },
    // offer picking states in rule-template next to metrics
    states: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hasTwinEditPermission: {
      type: Boolean,
      required: false,
      default: false
    },
    formValid: {
      type: Boolean,
      required: false,
      default: false
    },
    template: {
      type: Object,
      required: false,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      executionResultPrompt: false,
      lastExecutionResult: null,
      textboxFields: ['payload', 'html', 'text', 'frm_payload'],
      commands: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    printedMetricTemplates: function printedMetricTemplates() {
      return (get(this.rule, 'properties.stateMetrics') || []).map(function (metric) {
        return "{{ ".concat(metric.key, " }}");
      }).join(', ');
    },
    printedCustomKVTemplates: function printedCustomKVTemplates() {
      return Object.keys(get(this.dtwin, 'data.keyValue') || {}).map(function (key) {
        return "{{ ".concat(key, " }}");
      }).join(', ');
    },
    twinType: function twinType() {
      return get(this.dtwin, 'properties.type');
    },
    getColumnWidth: function getColumnWidth() {
      var _this2 = this;

      return function (param, paramConfig) {
        if (paramConfig.width && ['m', 'l'].indexOf(paramConfig.width) >= 0) {
          return param.width === 'm' ? 6 : 12;
        }

        return _this2.textboxFields.includes(param) ? 12 : 4;
      };
    },
    isTemplateContext: function isTemplateContext() {
      return !isEmpty(this.template);
    }
  }),
  watch: {
    rule: function rule() {
      this.processRuleActions();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.fetchBridges().then(function () {
      _this3.processRuleActions(); // clear incorrect parameters properties from actions (params should match command manifest definition)


      _this3.rule.properties.actions.forEach(function (action) {
        var definedParamsKeys = Object.keys(_this3.parametersForCommandId(action.command));

        for (var key in action.params) {
          if (!definedParamsKeys.includes(key)) {
            delete action.params[key];
          }
        }
      });
    }).catch(function (error) {
      console.error('Error fetching bridges', error);
    });
  },
  methods: {
    removeTemplateState: function removeTemplateState(stateId) {
      this.rule.properties.actionTemplateStateIds.splice(this.rule.properties.actionTemplateStateIds.indexOf(stateId), 1);
      this.rule.properties.actionTemplateStateIds = _toConsumableArray(this.rule.properties.actionTemplateStateIds);
    },
    refreshTemplateStates: function refreshTemplateStates() {
      this.rule.properties = cloneDeep(this.rule.properties);
    },
    commandChange: function commandChange(index) {
      var _this4 = this;

      var changedAction = this.rule.properties.actions[index];
      var newParamsKeys = Object.keys(this.parametersForCommandId(changedAction.command));
      var currentParamsKeys = Object.keys(changedAction.params);
      var keysToRemove = currentParamsKeys.filter(function (key) {
        return !newParamsKeys.includes(key);
      });
      keysToRemove.forEach(function (key) {
        delete _this4.rule.properties.actions[index].params[key];
      });
      this.$emit('command-changed', index);
    },
    processRuleActions: function processRuleActions() {
      if (!isArray(this.rule.properties.actionTemplateStateIds)) {
        this.rule.properties.actionTemplateStateIds = [];
      } // change boolean values to string "true"/"false"
      // so they are selectable in the v-select
      // the XAPI offers/changes these trigger-values to proper booleans, but the v-select only has string-values
      // so this little "hack" maps everything back - the rule-trigger handles both cases anyway, and the XAPI maps them back to boolean


      var conditionsDisabled = this.rule.properties.conditionEnabled === false || this.rule.properties.timeTriggerOnly;
      this.rule.properties.actions.forEach(function (action) {
        action.triggerValue = conditionsDisabled ? 'true' : "".concat(action.triggerValue || true).toLowerCase();
      });
    },
    formattedTemplateState: function formattedTemplateState(state) {
      return "{{state:".concat(state.key, "}}");
    },
    formattedVariable: function formattedVariable(metric) {
      return "{{".concat(metric.key, "}}");
    },
    fetchBridges: function fetchBridges() {
      var _this5 = this;

      return Promise.all([ApiService.getBridgeTypes().then(function (bridgeTypes) {
        return bridgeTypes.filter(function (type) {
          // only display bridges that have instance commands
          return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0;
        });
      }), ApiService.getBridgesForTenant(this.isTemplateContext ? this.template.tenantId : this.dtwin.tenantId)]).then(function (results) {
        var commands = [];
        results[1].forEach(function (bridgeInstance) {
          var bridgeTypeDef = results[0].find(function (bridgeDef) {
            return bridgeDef.type === bridgeInstance.type;
          });
          var instanceCmds = get(bridgeTypeDef, 'manifest.commands.instance', {});
          commands = commands.concat(Object.keys(instanceCmds).map(function (commandName) {
            if (instanceCmds[commandName].internal) {
              return null;
            }

            return _objectSpread(_objectSpread({}, instanceCmds[commandName]), {}, {
              name: "".concat(bridgeInstance.name, ".").concat(commandName),
              id: "".concat(bridgeInstance.id, ".").concat(commandName),
              bridgeType: bridgeInstance.type,
              config: get(bridgeInstance, 'bridge.config', {}),
              configId: bridgeInstance.id,
              manifest: bridgeTypeDef.manifest
            });
          }));
        });
        _this5.commands = compact(commands).filter(function (b) {
          var type = results[0].find(function (t) {
            return t.type === b.bridgeType;
          });
          return get(type, 'manifest.functionScope.invokeDirection.outbound', false);
        });
      });
    },
    findByCommandId: function findByCommandId(commandId) {
      return this.commands.find(function (c) {
        return c.id === commandId;
      });
    },
    orderedParamKeysForCommandId: function orderedParamKeysForCommandId(commandId) {
      var parameters = this.parametersForCommandId(commandId);
      return Object.keys(parameters).sort(function (a, b) {
        var orderIdxA = parameters[a].orderIdx || 0;
        var orderIdxB = parameters[b].orderIdx || 0;

        if (orderIdxA < orderIdxB) {
          return -1;
        }

        if (orderIdxA > orderIdxB) {
          return 1;
        }

        return a.localeCompare(b);
      });
    },
    parametersForCommandId: function parametersForCommandId(commandId) {
      return get(this.findByCommandId(commandId), 'parameters', {});
    },
    testExecuteAction: function testExecuteAction(index, action) {
      var _this6 = this;

      ApiService.digitalTwinRuleExecuteAction(this, {
        action: action,
        ruleObj: JSON.parse(JSON.stringify(_objectSpread(_objectSpread({}, this.rule), {}, {
          dtwinId: this.isTemplateContext ? null : this.dtwin.id
        }))),
        templateId: this.isTemplateContext ? this.template.id : null
      }).then(function (result) {
        _this6.lastExecutionResult = result;

        _this6.$snack(_this6.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionSuccessful'), 'success', {
          message: _this6.$i18n_t('Common.viewDetails'),
          click: function click() {
            _this6.executionResultPrompt = true;
          }
        });
      }).catch(function (error) {
        var errorRespData = get(error, 'response.data.data');
        var errorTranslation = errorRespData ? _this6.$i18n_t("Error.".concat(errorRespData)) : null;
        var errorDetails = errorRespData && errorTranslation !== "Error.".concat(errorRespData) ? errorTranslation : get(error, 'response.data.data');

        if (_typeof(errorDetails) === 'object') {
          errorDetails = JSON.stringify(errorDetails);
        }

        _this6.lastExecutionResult = get(error, 'response.data.message') ? "".concat(error.response.data.message, ": ").concat(errorDetails) : error.toString();

        _this6.$snack(_this6.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionFailed'), 'error', {
          message: _this6.$i18n_t('Common.viewDetails'),
          click: function click() {
            _this6.executionResultPrompt = true;
          }
        });
      });
    },
    getStateKey: function getStateKey(item) {
      if (this.isTemplateContext) {
        return (this.states.find(function (s) {
          return s.key === item;
        }) || {}).key;
      } else {
        return (this.states.find(function (s) {
          return s.id === item;
        }) || {}).key;
      }
    }
  }
};